const stepperData = [
  "施設選択",
  "対象施設一覧/解除内容入力",
  "入力内容確認",
  "機構へ提出",
];

const headList = [
  {
    headTitle: "施設名称",
  },
  {
    headTitle: "施設区分",
  },
  {
    headTitle: "施設種類",
  },
  {
    headTitle: "処理状況",
  },
  {
    headTitle: "解除情報",
  },
];

const contextText = `入力された解除年月日以降の退職(予定)年月日・異動情報(配置換え)が入力されている職員が存在します。
このまま部分解除の申請を進めると、退職(予定)年月日・異動情報(配置換え)が削除されますがよろしいですか`;

export { stepperData, headList, contextText };
